import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'safeHtml',
    pure: false,
})
export class SafeHtmlPipe implements PipeTransform {
    constructor(
        private translate: TranslateService,
        private sanitized: DomSanitizer,
    ) {}

    transform(value) {
        return this.sanitized.bypassSecurityTrustHtml(value);
    }
}
